<template>
  <el-card class="my-box-card">
    <el-form :model="userInfo" ref="userInfoForm" label-width="120px" label-position="right" :rules="rules" size="small">
      <el-divider>单位信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="单位名称" prop="webUserCompany.companyName">
            <el-input v-model="userInfo.webUserCompany.companyName" :disabled="!isManager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="纳税人识别号" prop="webUserCompany.companyCode">
            <el-input v-model="userInfo.webUserCompany.companyCode" :disabled="!isManager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="单位地址" prop="webUserCompany.companyAddress">
            <el-input v-model="userInfo.webUserCompany.companyAddress" :disabled="!isManager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮政编码" prop="webUserCompany.postCode">
            <el-input v-model="userInfo.webUserCompany.postCode" :disabled="!isManager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="website" label="网站">
            <el-input type="text" :disabled="!isManager" v-model="userInfo.webUserCompany.website" auto-complete="off" placeholder="请输入网站" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider>个人信息</el-divider>
      <el-row>
        <el-col :span="12">
          <el-form-item label="用户名" prop="account">
            {{userInfo.account}}
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="userInfo.mobile"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托人签名" prop="name">
            <el-input v-model="userInfo.name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="电子邮箱" prop="mailBox">
            <el-input v-model="userInfo.mailBox"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-divider></el-divider>
    <div class="clearfix" style="text-align: center">
      <el-button size="medium" type="primary" @click="handleSave">保存</el-button>
    </div>
  </el-card>
</template>

<script>
import { editUser } from '@/api/user/user'
import { isMobileRegistered } from '@/api/user/login'

export default {
  name: 'userInfo',
  data () {
    const validateMobile = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号码'))
      } else if (this.oldMoblie === value) {
        callback()
      } else {
        let param = {}
        param.mobile = value
        isMobileRegistered(param).then(response => {
          if (response.data.rtnCode === '0') {
            callback()
          } else {
            callback(new Error(response.data.msg))
          }
        })
      }
    }
    return {
      isManager: false,
      oldMoblie: '',
      userInfo: {
        name: '',
        mailBox: '',
        mobile: '',
        webUserCompany: {
          companyName: '',
          companyCode: '',
          companyAddress: '',
          postCode: '',
          website: ''
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        mobile: [
          {
            pattern: /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/,
            message: '请输入正确的电话号码'
          },
          { required: true, validator: validateMobile, trigger: 'blur' }
        ],
        mailBox: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        'webUserCompany.companyCode': [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        'webUserCompany.companyName': [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        'webUserCompany.companyAddress': [
          { required: true, message: '请输入单位地址', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    user () {
      return this.$store.state.user.userInfo
    },
    companyInfo () {
      return this.$store.state.user.companyInfo
    },
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  mounted () {
    if (this.user) {
      this.userInfo.id = this.user.id
      this.userInfo.account = this.user.account
      this.userInfo.mobile = this.user.mobile
      this.oldMoblie = this.user.mobile
      if (this.user.name) {
        this.userInfo.name = this.user.name
      }
      if (this.user.mailBox) {
        this.userInfo.mailBox = this.user.mailBox
      }
      if (this.user.isManager === '0') {
        this.isManager = true
      } else {
        this.isManager = false
      }
    }
    if (this.companyInfo) {
      this.userInfo.webUserCompany = {
        companyName: this.companyInfo.companyName,
        companyCode: this.companyInfo.companyCode,
        companyAddress: this.companyInfo.companyAddress,
        postCode: this.companyInfo.postCode,
        website: this.companyInfo.website
      }
    } else {
      this.userInfo.webUserCompany = {
        companyName: '',
        companyCode: '',
        companyAddress: '',
        postCode: '',
        website: ''
      }
    }
  },
  methods: {
    handleSave () {
      this.$refs['userInfoForm'].validate(valid => {
        if (valid) {
          editUser(this.userInfo).then(res => {
            var result = res.data
            if (result.rtnCode !== '0') {
              this.$message({
                type: 'info',
                message: result.msg
              })
            } else {
              this.$message.success('提交成功！')
              this.$router.go(0)
            }
          }).catch(ex => {
            this.loading = false
            this.$message.error('获取详情失败，请稍后再试！')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
